export const settings = {
    "title": "We Bocs",
    "description": "we bocs",
    "apiUrl": "https://api.webocs.com/api",
    "ckdPath": "https://api.webocs.com/"
}